import { CimpressDocument, DesignSurface } from '@mcp-artwork/cimdoc-types-v2'
import { GenerateDesignProduct } from '../../api/smartDesignEngine'
import { v4 as uuidv4 } from 'uuid'
import { generateMainPanel } from './generateMainPanel'
import { generateSecondaryPanel } from './generateSecondaryPanel'
import { ImageWithDimensions } from '../image'
import { DesignView, ProductsAndDesignSpecificationsResponse } from './targetSpecifications/types'
import { getTargetSpecificationForProduct } from './targetSpecifications/client'
import { Tone } from '../imageEffects'

export async function generateDesignDocumentForProduct(
  product: GenerateDesignProduct,
  culture: string,
  logo: ImageWithDimensions,
  backgroundColor: string,
  tone: Tone,
): Promise<CimpressDocument> {
  let specifications: ProductsAndDesignSpecificationsResponse = await getTargetSpecificationForProduct(
    product.productId,
    product.productVersion,
    product.productOptions,
    culture,
  )

  if (!specifications.designViews || specifications.designViews.length === 0) {
    throw new Error('Missing panel data, cannot generate design for ' + product.mpvId)
  }

  return createCimDoc(specifications.designViews, specifications.projectionId || '', logo, backgroundColor, tone)
}

function createCimDoc(
  panels: DesignView[],
  projectionId: string,
  logo: ImageWithDimensions,
  backgroundColor: string,
  tone: Tone,
): CimpressDocument {
  const mainPanelId = uuidv4()

  function generatePanel(panel: DesignView, index: number): DesignSurface {
    if (index === 0) {
      return generateMainPanel(panel, logo, backgroundColor, mainPanelId, tone)
    } else {
      return generateSecondaryPanel(panel)
    }
  }

  return {
    document: {
      panels: panels.map(generatePanel),
    },
    version: '2.0',
    fontRepositoryUrl: 'https://fonts.documents.cimpress.io/v1/repositories/0a3b1fba-8fa6-43e1-8c3e-a018a5eb8150/published',
    projectionId: projectionId,
    metadata: {
      ddifVersion: '2.0',
      documentSources: {
        panels: [
          {
            id: `${mainPanelId}`,
            source: 'LOGO2LIFE',
            data: '',
          },
        ],
      },
    },
  }
}
